import {
  Sun, Moon, Star, Flame, Heart, KeyRound, Wine, Compass, Brain, Clover,
  ShieldCheck, Home, Bird, Baby, MapPin, Car, Plane, Smile, PartyPopper,
  Tv, Globe, MessageCircle, Mountain, ChefHat, Palette, Hourglass, Infinity as InfinityIcon, HandHeart, Gift,
} from "lucide-react";

const ICONS = {
  sun: Sun,
  moon: Moon,
  star: Star,
  flame: Flame,
  heart: Heart,
  key: KeyRound,
  chalice: Wine,
  compass: Compass,
  eye: Brain,
  wheel: Clover,
  hands: HandHeart,
  shield: ShieldCheck,
  home: Home,
  dove: Bird,
  baby: Baby,
  whiteheart: Heart,
  pin: MapPin,
  car: Car,
  plane: Plane,
  smile: Smile,
  wine: Wine,
  party: PartyPopper,
  tv: Tv,
  globe: Globe,
  chat: MessageCircle,
  hourglass: Hourglass,
  infinity: InfinityIcon,
  gift: Gift,
  mountain: Mountain,
  chef: ChefHat,
  art: Palette,
};

export const ArcanaIcon = ({ name = "star", size = 56, className = "" }) => {
  const Icon = ICONS[name] || Star;
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full border border-gold/40 bg-gold-light ${className}`}
      style={{ width: size, height: size }}
    >
      <Icon size={Math.round(size * 0.44)} className="text-terra" strokeWidth={1.8} />
    </span>
  );
};
